import { render } from "./viewInvoice.vue?vue&type=template&id=86fa06b4&scoped=true"
import script from "./viewInvoice.vue?vue&type=script&lang=js"
export * from "./viewInvoice.vue?vue&type=script&lang=js"

import "./viewInvoice.vue?vue&type=style&index=0&id=86fa06b4&scoped=true&lang=css"

import exportComponent from "/Users/zonegoh/Documents/GitHub/level-up/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86fa06b4"]])

export default __exports__